import _Divider from "@mui/material/Divider";
import _Skeleton from "@mui/material/Skeleton";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Button2 from "@mui/material/Button";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import moment from 'moment';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { defaultEnvironment } from '../../environment';
import { getCampaignFamilyConfig } from '../../event-campaigns';
import { useChallenge, useUnits } from '../../hooks';
import CustomPointsDialogButton from '../event-details/custom-points-dialog-button';
import { CalendarIcon, CupIcon, PeopleIcon, TargetIcon } from '../icons';
import { challengeCollaborationTypesMap } from './collabation-type-chip';
import { ChallengeCardProgressionDescription } from './progression-description';
import { ChallengeCardProgressionHighlight } from './progression-highlight';
const now = moment();
export function ChallengeCardData({
  Button: _Button,
  Dialog,
  containerProps,
  geogroup,
  challenge,
  event,
  enableCollaborationType,
  enableMembersCount,
  disableDaysCount,
  disableProgression,
  enableUserProgression,
  enableProgressionHighlight: _enableProgressionHighlight,
  enableProgressionDescription,
  hideSponsor,
  userChallenge,
  onFAQClick
}) {
  const {
    t
  } = useTranslation();
  const {
    getFormattedProgressValue
  } = useChallenge();
  const {
    formatNumber,
    toOrdinal,
    toDistance
  } = useUnits();
  const Button = _Button || _Button2;
  const startDate = challenge?.startDate;
  const endDate = challenge?.endDate;
  const sameYear = startDate && endDate && startDate.get('year') === endDate.get('year');
  const sameMonthAndYear = sameYear && startDate.get('month') === endDate.get('month');
  const from = startDate?.format(sameMonthAndYear ? 'DD' : sameYear || startDate.get('year') === now.get('year') ? 'DD MMMM' : 'DD MMMM YYYY');
  const to = endDate?.format(endDate.get('year') === now.get('year') ? 'DD MMMM' : 'DD MMMM YYYY');
  const collaborationContext = challenge?.subGroupDisplay === 'companySite' ? 'sites' : challenge?.collaborationType;
  const targetCollaborationContext = challenge && collaborationContext ? challenge.targetValue ? collaborationContext : `${collaborationContext}_no_target` : undefined;
  const teamLeaderboard = challenge?.collaborationType === 'teams' && userChallenge && userChallenge.subgroupsLeaderboards?.find(({
    subGroupType
  }) => subGroupType === challenge.subGroupDisplay) || null;
  const enableProgressionHighlight = challenge && challenge.period === 'future' ? false : _enableProgressionHighlight || false;
  const familyConfig = getCampaignFamilyConfig(event?.code);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, ((!challenge || 'nbMembers' in challenge) && enableProgressionHighlight || event && event.challengeTemplate?.type !== 'bttf' && event.challengeTemplate?.type !== 'custom' && (event.isPublic || event.dedicatedWebsiteUrl)) && /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, (!challenge || 'nbMembers' in challenge) && enableProgressionHighlight && /*#__PURE__*/React.createElement(ChallengeCardProgressionHighlight, {
    challenge: challenge,
    enableUserProgression: enableUserProgression,
    teamLeaderboard: teamLeaderboard,
    userChallenge: userChallenge
  }), event && event.challengeTemplate?.type !== 'bttf' && event.challengeTemplate?.type !== 'custom' && (event.isPublic || event.dedicatedWebsiteUrl) && /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#F3F6FF",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("a", {
      href: event.dedicatedWebsiteUrl || `${defaultEnvironment.eventsSiteUrl}${event.id}`,
      key: 0,
      rel: "noreferrer",
      style: {
        color: '#326ac2'
      },
      target: "_blank"
    })],
    i18nKey: "commons.challenges.display_all_leaderboards",
    values: {
      url: (event.dedicatedWebsiteUrl || `${defaultEnvironment.eventsSiteUrl}${event.id}`).replace('https://', '').replace('http://', '')
    }
  })))), !hideSponsor && (event?.sponsor || challenge?.sponsor) && /*#__PURE__*/React.createElement(_Box, {
    paddingX: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontStyle: "italic",
    variant: "body2"
  }, t('commons.challenges.sponsored_by', {
    sponsor: event?.sponsor || challenge?.sponsor
  }))), /*#__PURE__*/React.createElement(_Box, _extends({
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, containerProps), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(CalendarIcon, {
    color: challenge ? 'primary' : 'action',
    sx: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontWeight: 700,
      fontSize: 16
    },
    variant: "body2"
  }, challenge ? /*#__PURE__*/React.createElement(React.Fragment, null, disableDaysCount || challenge.daysLeft < 0 ? t('commons.periods.from_to', {
    from,
    to
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, challenge.daysToWait > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, startDate && endDate ? `${startDate.format('D MMMM')} - ${endDate.format('D MMMM YYYY')}` : t('commons.challenges.days_to_wait', {
    count: challenge.daysToWait
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, t('commons.challenges.days_left', {
    count: challenge.daysLeft
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))), challenge && !disableDaysCount && challenge.daysLeft >= 0 && challenge.daysToWait <= 0 && /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, t('commons.periods.from_to', {
    from,
    to
  })))), (!challenge || challenge.type !== 'noTarget') && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(CupIcon, {
    color: challenge ? 'primary' : 'action',
    sx: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontWeight: 700,
      fontSize: 16
    },
    variant: "body2"
  }, challenge ? challenge.type === 'bttf' ? t('commons.challenges.types.bttf_description', {
    context: targetCollaborationContext,
    count: challenge.targetValue
  }) : challenge.type === 'custom' ? t('commons.challenges.types.custom_description', {
    context: targetCollaborationContext,
    count: challenge.targetValue
  }) : challenge.type === 'traveledDistance' ? t('commons.challenges.types.distance_description', {
    context: targetCollaborationContext,
    distance: toDistance(challenge.targetValue)
  }) : challenge.type === 'cyclingDays' ? t('commons.challenges.types.cycling_days_description', {
    context: collaborationContext,
    count: challenge.targetValue
  }) : t('commons.challenges.types.journeys_description', {
    context: collaborationContext,
    count: challenge.targetValue
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, challenge ? challenge.traceType === 'commuting' || challenge.type === 'homeWorkJourneysCount' ? t('commons.challenges.types.considered_journeys_home_work') : t('commons.challenges.types.considered_journeys_all') : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), event?.challengeTemplate?.type === 'bttf' && onFAQClick && /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => onFAQClick(),
    size: "small",
    sx: {
      fontSize: 14,
      fontWeight: 700,
      lineHeight: 1.15,
      paddingLeft: 0
    },
    variant: "text"
  }, t('commons.challenges.bttf_faq.title'))), event?.challengeTemplate?.type === 'custom' && event.challengeTemplate.metricsWeights && /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(CustomPointsDialogButton, {
    Button: _Button,
    Dialog: Dialog,
    metricsWeights: event.challengeTemplate.metricsWeights,
    onFaqClick: familyConfig?.hasFaqLinkInPointsDialog ? onFAQClick : undefined
  })))), event?.challengeTemplate?.type === 'bttf' || familyConfig?.showCompanyParticipantsCount ? /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(PeopleIcon, {
    color: challenge ? 'primary' : 'action',
    sx: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontWeight: 700,
      fontSize: 16
    },
    variant: "body2"
  }, t('commons.challenges.participants_company', {
    count: event?.numberOfParticipants
  }))) : enableCollaborationType && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(PeopleIcon, {
    color: challenge ? 'primary' : 'action',
    sx: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontWeight: 700,
      fontSize: 16
    },
    variant: "body2"
  }, challenge ? t(challengeCollaborationTypesMap[challenge.collaborationType === 'global' ? 'individual' : challenge.collaborationType].labelKey) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))), (!challenge || 'nbMembers' in challenge) && enableMembersCount && !familyConfig?.showCompanyParticipantsCount && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(PeopleIcon, {
    color: challenge ? 'primary' : 'action',
    sx: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontWeight: 700,
      fontSize: 16
    },
    variant: "body2"
  }, challenge ? t('commons.challenges.participants', {
    count: challenge.nbMembers
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))), !disableProgression && !enableProgressionHighlight && (!challenge || challenge.period !== 'future' && 'nbMembers' in challenge && (challenge.targetValue || enableUserProgression) && (challenge.collaborationType !== 'teams' || teamLeaderboard)) && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(TargetIcon, {
    color: challenge ? 'primary' : 'action',
    sx: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontWeight: 700,
      fontSize: 16
    },
    variant: "body2"
  }, challenge ? challenge.collaborationType === 'teams' ? teamLeaderboard && t('commons.challenges.rank_team_short', {
    count: teamLeaderboard.countSubgroupOfSameType,
    rank: toOrdinal(teamLeaderboard.rank, {
      feminine: true
    })
  }) : userChallenge?.rank ? t('commons.challenges.rank_short', {
    nbMembers: formatNumber(challenge.nbMembers),
    count: challenge.nbMembers,
    rank: toOrdinal(userChallenge.rank, {
      inclusive: true
    })
  }) : getFormattedProgressValue(challenge) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), challenge?.period === 'past' && /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t('commons.challenges.well_done')))), familyConfig?.hasFaqDescriptionInCard && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Divider, null), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "body2"
  }, t('commons.challenges.bfg_faq.description'))))), (!challenge || challenge.period !== 'future' && (challenge.collaborationType === 'global' || enableUserProgression)) && enableProgressionDescription && /*#__PURE__*/React.createElement(ChallengeCardProgressionDescription, {
    Button: _Button,
    challenge: challenge,
    Dialog: Dialog,
    geogroup: geogroup
  }));
}